/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { UserListToolbar } from '../../sections/@dashboard/user';

const ContractFilters = ({ numSelected, filterName, onFilterName }) => {
  return <UserListToolbar numSelected={numSelected} filterName={filterName} onFilterName={onFilterName} />;
};

ContractFilters.propTypes = {
  numSelected: PropTypes.number.isRequired,
  filterName: PropTypes.string.isRequired,
  onFilterName: PropTypes.func.isRequired,
};

export default ContractFilters;
